import getDevice from '@clearscore-group/lib.helpers.device';
import { executeWhenCookiesAccepted } from '@clearscore-group/lib.hooks.use-tracking';
import { MARKETS } from '@clearscore/config.i18n';
import '@clearscore/ui.rainbow.tokens/tokens.css';
import '@clearscore/ui.rainbow.drivescore.tokens/tokens.css';
import type { GatsbyBrowser } from 'gatsby';
import ReactDOM from 'react-dom/client';

import ProviderWrapper from './src/components/provider-wrapper';

const market = process.env.MARKET || MARKETS[0];
const device = getDevice();
const PAGE_VIEW_WEBSITE_NAME = 'well_good_homepage';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
    document.cookie = 'site_version=new;Path=/;Max-Age=2592000;';
    // it requires a polyfill for IE11 and android < 5
    if (typeof window.URLSearchParams === `undefined`) {
        import('url-search-params-polyfill');
    }
    if (typeof window.IntersectionObserver === 'undefined') {
        import('intersection-observer'); // needed for safari <=12.0
    }
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
    executeWhenCookiesAccepted(() => {
        if (window.analytics) {
            window.analytics.page({
                cs_site: market,
                cs_ed: new Date(),
                device,
                website: PAGE_VIEW_WEBSITE_NAME,
            });
        }
    });
};

export const replaceHydrateFunction = () => (element, container) => {
    if (process.env.NODE_ENV === 'production') {
        ReactDOM.hydrateRoot(container, element);
    } else {
        const root = ReactDOM.createRoot(container);
        root.render(element);
    }
};

export const wrapRootElement = ProviderWrapper;
